export const isInPhoneOrTablet = () => {
    if (window.matchMedia('(max-width: 768px)').matches) {
        return true
    }
    return false
}
